import React from 'react';

const Overlay = () => (
    <div className="pagewrap-overlay d-none d-lg-block">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
    </div>
);

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay.js